import {
    INVALID_PASSWORD_CONFIRMATION,
    INVALID_PASSWORD_CONFIRMATION_LENGTH,
    VALID_PASSWORD_CONFIRMATION,
    VALID_PASSWORD_CONFIRMATION_LENGTH,
} from '../actionTypes';
import { resetPasswordActions } from '../reducer';

export default (event, values) => (dispatch) => {
    const password = values.password;

    const password_confirmation = event.target.value;

    if (password_confirmation.length >= 8) {
        dispatch(resetPasswordActions[VALID_PASSWORD_CONFIRMATION_LENGTH]());
    } else {
        dispatch(resetPasswordActions[INVALID_PASSWORD_CONFIRMATION_LENGTH]());
    }

    if (password_confirmation === password) {
        dispatch(resetPasswordActions[VALID_PASSWORD_CONFIRMATION]());
    } else {
        dispatch(resetPasswordActions[INVALID_PASSWORD_CONFIRMATION]());
    }
};
